var exports = {
  "lq": "Hero__GIS2pr",
  "fh": "Cell__92q9am",
  "hE": "Title__iJqohq",
  "tK": "SubTitle__0x2RYm",
  "Cj": "EyebrowMobile__qoY-EM",
  "IB": "EyebrowDesktop__355PAE",
  "VY": "Description__fQqmia",
  "D5": "CtaNote__8lyeKp",
};

module.exports = exports;
